// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".object-fit-cover[data-v-808ac7c2]{-o-object-fit:cover;object-fit:cover}.large[data-v-808ac7c2]{width:100%;height:270px;max-height:270px}@media (min-width:768px){.large[data-v-808ac7c2]{height:540px;max-height:540px}}.small[data-v-808ac7c2]{width:100%;height:80px;max-height:80px}@media (min-width:768px){.small[data-v-808ac7c2]{height:160px;max-height:160px}}", ""]);
// Exports
module.exports = exports;
